import { gql } from '@apollo/client';

export const GET_BRANDS = gql`
    query GetBrands($query: String, $pagination: Pagination, $filter: BrandFilterUpercut, $proId: ID) {
        getBrands(query: $query, pagination: $pagination, filter: $filter, proId: $proId) {
            meta {
                totalDocs
                limit
                page
                totalPages
            }
            docs {
                _id
                brandName
                description
                createdAt
                updatedAt
                isFeatured
                sector {
                    _id
                    sectorName
                }
                brandLogo {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandBanner {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandPhotos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandVideos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                pro {
                    _id
                    commercialName
                }
            }
        }
    }
`;

export const GET_BRANDS_UPERCUT_FILTERED = gql`
    query getBrandsUpercutFiltered($query: String, $pagination: Pagination, $filter: BrandFilterUpercut, $proId: ID) {
        getBrandsUpercut(query: $query, pagination: $pagination, filter: $filter, proId: $proId) {
            meta {
                totalDocs
                limit
                page
                totalPages
            }
            docs {
                _id
                brandName
                description
                isFeatured
                createdAt
                updatedAt
                sector {
                    _id
                    sectorName
                }
                brandLogo {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandBanner {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandPhotos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandVideos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                pro {
                    _id
                    commercialName
                }
            }
        }
    }
`;

export const GET_BRANDS_UPERCUT = gql`
    query getBrandsUpercut($query: String, $pagination: Pagination, $proId: ID) {
        getBrandsUpercut(query: $query, pagination: $pagination, proId: $proId) {
            meta {
                totalDocs
                limit
                page
                totalPages
            }
            docs {
                _id
                brandName
                description
                isFeatured
                sector {
                    _id
                    sectorName
                }
                brandLogo {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandBanner {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandPhotos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                brandVideos {
                    _id
                    url
                    name
                    size
                    mimetype
                }
                pro {
                    _id
                    commercialName
                }
            }
        }
    }
`;

export const GET_BRAND = gql`
    query GetBrand($id: ID!) {
        getBrand(_id: $id) {
            _id
            brandName
            description
            isFeatured
            sector {
                _id
                sectorName
            }
            brandLogo {
                _id
                url
                name
                size
                mimetype
            }
            brandBanner {
                _id
                url
                name
                size
                mimetype
            }
            brandPhotos {
                _id
                url
                name
                size
                mimetype
            }
            brandVideos {
                _id
                url
                name
                size
                mimetype
            }
            geoLocations {
                _id
                address
                lat
                lng
                city
                postal
            }
            pro {
                _id
                commercialName
            }
        }
    }
`;

export const ADD_BRAND = gql`
    mutation addBrand($brandInput: BrandInput!, $proId: ID) {
        addBrand(brandInput: $brandInput, proId: $proId) {
            _id
            brandName
            description
            isFeatured
            pro {
                _id
                commercialName
            }
        }
    }
`;

export const UPDATE_BRAND = gql`
    mutation updateBrand($id: ID!, $brandInput: BrandInput!) {
        updateBrand(_id: $id, brandInput: $brandInput) {
            _id
            brandName
            description
            isFeatured
            brandLogo {
                _id
                url
            }
            brandBanner {
                _id
                url
            }
            pro {
                _id
                commercialName
            }
        }
    }
`;

export const DELETE_BRANDS = gql`
    mutation deleteBrand($ids: [ID!]!) {
        deleteBrand(_ids: $ids) {
            _id
        }
    }
`;

export const UPDATE_BRANDS_FEATURED = gql`
    mutation updateBrandsFeatured($ids: [ID!]!, $isFeatured: Boolean!) {
        updateBrandsFeatured(_ids: $ids, isFeatured: $isFeatured) {
            _id
            isFeatured
        }
    }
`;

export const UPDATE_GEO_LOCATION_BRAND = gql`
    mutation updateGeoLocationBrand($brandId: ID, $geoLocations: [InputBrandGeoLocation], $shouldDelete: Boolean) {
        updateGeoLocationBrand(brandId: $brandId, geoLocations: $geoLocations, shouldDelete: $shouldDelete) {
            _id
            brandName
            geoLocations {
                _id
                address
                lat
                lng
                city
                postal
            }
        }
    }
`;
